'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$189() {
  this.c2n = null;
  this.c2l = null;
  this.c2m = false;
  this.c2j = null;
  this.c2k = false;
  this.c2o = false;
  this.c2p = false;
  this.c2n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$189 as $c_Lpresto_types$$anon$189 };
$p = $c_Lpresto_types$$anon$189.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$189;
/** @constructor */
function $h_Lpresto_types$$anon$189() {
}
export { $h_Lpresto_types$$anon$189 as $h_Lpresto_types$$anon$189 };
$h_Lpresto_types$$anon$189.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.c2n;
});
$p.t = (function() {
  if ((!this.c2m)) {
    this.c2l = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2m = true;
  }
  return this.c2l;
});
$p.ae = (function() {
  if ((!this.c2k)) {
    this.c2j = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rq, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2k = true;
  }
  return this.c2j;
});
$p.w = (function() {
  if ((!this.c2p)) {
    this.c2o = false;
    this.c2p = true;
  }
  return this.c2o;
});
$p.acz = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ac = (function(a) {
  return this.acz(a);
});
var $d_Lpresto_types$$anon$189 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$189, "presto.types$$anon$189", ({
  Y8: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$189 as $d_Lpresto_types$$anon$189 };
//# sourceMappingURL=presto.types$$anon$189.js.map
